import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 15000, // 15s — prevents infinite hang on slow mobile wakeup
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("pv_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

apiClient.interceptors.response.use(
  (r) => r,
  (error) => {
    // IMPORTANT: Do NOT modify localStorage or auth state here.
    // AuthContext.refresh() is the single source of truth for session state.
    // It handles 401 from /auth/me correctly (clears session on token expiry).
    // Clearing pv_token here on transient 401s from other endpoints was causing
    // false logouts — especially on mobile with unstable connections.
    return Promise.reject(error);
  }
);

export default apiClient;
